<template>
	<div class="information">
		<el-form ref="ruleForm" label-width="120px" style="overflow: hidden;"
			class="demo-ruleForm border-bottom margin-top2">
			<el-row>
				<el-col :span="6">
					<el-form-item label="到货状态" prop="Jieshutime">
						<el-select v-model="ruleForm.arrivalStatus" placeholder="请选择" clearable style="width:220px;">
							<el-option label="未处理" :value="0"></el-option>
							<el-option label="正常" :value="1"></el-option>
							<el-option label="异常" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="数据是否正常" prop="Jieshutime">
						<el-select v-model="ruleForm.dataStatus" placeholder="请选择" clearable style="width:220px;">
							<el-option label="正常" :value="1"></el-option>
							<el-option label="异常" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="处理状态" prop="Jieshutime">
						<el-select v-model="ruleForm.handleStatus" placeholder="请选择" clearable style="width:220px;">
							<el-option label="已处理" :value="1"></el-option>
							<el-option label="未处理" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="开始日期" prop="starttime">
						<el-date-picker @change="startTime" v-model="ruleForm.startTimeString" align="right" type="date"
							placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="结束日期" prop="Jieshutime">
						<el-date-picker @change="endTime" v-model="ruleForm.endTimeString" align="right" type="date"
							placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item prop="searchInput" class="input">
						<el-input v-model="ruleForm.searchInput" placeholder="关键字" style="width: 55%;"></el-input>
						<el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
						<el-button type="primary" @click="resetFprm">重置</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-row>
			<el-col :span="24" class="padding">
				<el-row :gutter="20">
					<el-col :span="4"><el-button type="primary" @click="AddOtherprocurementedit"
							:disabled="!selectionList.length">批量标记处理状态</el-button></el-col>
				</el-row>
			</el-col>
		</el-row>

		<el-table :data="tableData" :header-cell-style="headClass" @selection-change="handleSelection" border
			style="width: 100%">
			<el-table-column type="selection" width="55" align="center"></el-table-column>
			<el-table-column prop="internalConveyNumber" label="国内运单" align="center"></el-table-column>
			<el-table-column prop="estimatedQuantity" label="商家预计发货数量" align="center"></el-table-column>
			<el-table-column prop="receivedQuantity" label="实际到库数量" align="center"></el-table-column>
			<el-table-column prop="approvedQuantity" label="信息核对正确数量" align="center"></el-table-column>
			<el-table-column prop="lackQuantity" label="缺件数量" align="center"></el-table-column>
			<el-table-column prop="mismatchQuantity" label="图货不符数量" align="center"></el-table-column>
			<el-table-column prop="damagedQuantity" label="破损数量" align="center"></el-table-column>
			<el-table-column prop="excessQuantity" label="多件数量" align="center"></el-table-column>
			<el-table-column prop="otherQuantity" label="其他数量" align="center"></el-table-column>
			<el-table-column prop="arrivalStatus" label="到货状态" align="center">
				<template slot-scope="scope">
					<el-tag type="warning" v-if="scope.row.arrivalStatus == 0">未处理</el-tag>
					<el-tag type="success" v-if="scope.row.arrivalStatus == 1">正常</el-tag>
					<el-tag type="danger" v-if="scope.row.arrivalStatus == 2">异常</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="dataStatus" label="数据状态" align="center">
				<template slot-scope="scope">
					<el-tag type="success" v-if="scope.row.dataStatus == 1">正常</el-tag>
					<el-tag type="danger" v-else>异常</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="handleStatus" label="处理状态" align="center">
				<template slot-scope="scope">
					<el-tag type="success" v-if="scope.row.handleStatus == 1">已处理</el-tag>
					<el-tag type="danger" v-else>未处理</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
			<el-table-column prop="receivedTime" label="运单入库时间" align="center"></el-table-column>
			<el-table-column prop="remark" label="备注" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<div style="padding-bottom: 6px;" @click="edit(scope.row)">
						<el-button type="primary">异常处理</el-button>
					</div>
					<el-button type="primary" @click="editRemark(scope.row)">修改备注</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page">
			<el-pagination style="margin-right:200px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[20, 50, 100, 200, 400]" :page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>

		<el-dialog width="40%" title="修改备注" :visible.sync="remarkVisible" append-to-body>
			<el-form :model="formRemark" :rules="rules" ref="ruleForm" label-width="60px">
				<el-form-item label="备注" style="width: 100%;">
					<el-input type="textarea" v-model="formRemark.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitRemark" :loading="isLoading">保 存</el-button>
			</div>
		</el-dialog>

		<ArrivaStatisticsedit ref="ArrivaStatisticsedit" @confirm="ArrivaStatisticsConfirm" />
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
import ArrivaStatisticsedit from "./ArrivaStatisticsedit/ArrivaStatisticsedit";
export default {
	name: "ArrivaStatistics",
	components: {
		ArrivaStatisticsedit
	},
	data() {
		return {
			headClass: this.common.headClass,
			currentPage: 1,
			pagesize: 20,
			size: 20,
			total: 0,
			ruleForm: {
				arrivalStatus: "",
				dataStatus: "",
				handleStatus: "",
				startTimeString: "",
				endTimeString: "",
				searchInput: ""
			},
			tableData: [],
			selectionList: [],
			remarkVisible: false,
			formRemark: { remark: '', internalConveyNumber: '' },
			rules: {
				remark: [
					{ required: true, message: '请填写备注', trigger: 'blur' }
				]
			},
			isLoading: false
		}
	},
	created() {
		this.str = JSON.parse(localStorage.getItem("role"));
		this.search()
	},
	methods: {
		edit(row) {
			this.$refs.ArrivaStatisticsedit.init(row);
		},
		searchForm() {
			this.currentPage = 1
			this.search()
		},
		search() {
			var obj = {
				page: this.currentPage,
				size: this.size,
				startTime: this.ruleForm.startTimeString,
				endTime: this.ruleForm.endTimeString,
				searchString: this.ruleForm.searchInput,
				arrivalStatus: this.ruleForm.arrivalStatus,
				dataStatus: this.ruleForm.dataStatus,
				handleStatus: this.ruleForm.handleStatus,
				companyId: this.str.company_id
			}
			ajaxPost(Baseurl + "logisticsInformationController/selectLogisticsPageInfo", obj).then(res => {
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
			});
		},
		resetFprm() {
			this.currentPage = 1
			this.ruleForm.startTimeString = ""
			this.ruleForm.endTimeString = ""
			this.ruleForm.searchInput = ""
			this.ruleForm.arrivalStatus = ""
			this.ruleForm.dataStatus = ""
			this.ruleForm.handleStatus = ""
			this.search()
		},
		startTime(val) {
			var d = new Date(val);
			var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00"
			this.ruleForm.startTimeString = datetime
		},
		endTime(val) {
			var d = new Date(val);
			var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59"
			this.ruleForm.endTimeString = datetime
		},
		handleSizeChange(val) {
			this.size = val
			this.search()
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.search()
		},
		AddOtherprocurementedit() {
			this.$confirm('此操作将选中数据标记为已处理, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				ajaxPost(Baseurl + "logisticsInformationController/batchMark", {
					idList: this.selectionList.map(x => x.id),
					handleStatus: 1
				}).then(() => {
					this.$message.success("标记成功")
					this.search()
				})
			})
		},
		handleSelection(list) {
			this.selectionList = list
		},
		editRemark(row) {
			this.remarkVisible = true
			this.formRemark.remark = row.remark
			this.formRemark.internalConveyNumber = row.internalConveyNumber
		},
		cancel() {
			this.remarkVisible = false
			this.formRemark = { remark: '', internalConveyNumber: '' }
		},
		submitRemark() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					this.isLoading = true
					ajaxPost(Baseurl + "logisticsInformationController/updateLogisticsInformation", this.formRemark).then(() => {
						this.$message.success("修改成功")
						this.isLoading = false
						this.search()
						this.cancel()
					}).catch(() => {
						this.isLoading = false
						this.$message.error("服务器出错，请联系客服")
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		ArrivaStatisticsConfirm(dataOut) {
			const API = Baseurl + "logisticsController/updatePurchaseExceptionResult";
			const paramsData = {
				roleId: this.str.rid,
				companyId: this.str.company_id,
				...dataOut,
			};
			ajaxPost(API, paramsData).then(res => {
				const { code, data } = res.data;
				if (code === 200) {
					this.$refs.ArrivaStatisticsedit.close();
					this.search();
					this.$message.success("操作成功");
				} else {
					this.$message.error(data || '操作失败');
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
/deep/ {
	.layout .layout-section ::-webkit-scrollbar {
		width: 10px;
		height: 10px;
		background-color: #b71e1e;
	}

	.input .el-form-item__content {
		margin-left: 23px !important;
	}
}

.information {
	width: 98%;
	overflow: hidden;
	padding-bottom: 60px;
}

.scope_img {
	width: 55px;
	height: 55px;

	img {
		width: 100%;
		height: 100%;
	}
}

.prduct_img {
	width: 500px;
	height: 500px;
}

.padding {
	padding: 10px 0;
}

.line-height {
	line-height: 45px;
}

.page {
	position: fixed;
	width: 100%;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
}
</style>
